(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 3076:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(3214);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7561);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1126);





function Footer(param) {
    let { links , locale  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)();
    const lang = locale || "fr";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                children: [
                    t("footer.title.1"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    " ",
                    t("footer.title.2"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    " ",
                    t("footer.title.3"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .FooterHeadingHand */ .dy, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "footer_links_page",
                children: links.map((l, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: l.href,
                        children: l.label
                    }, i))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: "footer_company_info",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        children: [
                            "Bene Bono\xae ",
                            new Date().getFullYear()
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: lang !== "es" && "https://static.horsnormes.co/static/legal/20220224-BeneBono-Politique-De-Confidentialite.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.privacynotice")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: lang !== "es" ? "https://static.horsnormes.co/static/legal/20241001-CGV-BeneBono.pdf" : "https://static.horsnormes.co/static/legal/CGV-spain.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.conditionsofuse")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://static.horsnormes.co/static/legal/20241001-BeneBono-MentionsLegales.pdf",
                        target: "_blank",
                        rel: "noreferrer",
                        children: t("footer.legal_mentions")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: t("footer.cookies")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .LogoFooter */ .vP, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_socials",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.instagram.com/benebono.es/" : "https://www.instagram.com/benebono.fr/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Instagram */ .mr, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.facebook.com/benebono.es/" : "https://www.facebook.com/benebono.fr/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Facebook */ .s1, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: lang === "es" ? "https://www.linkedin.com/company/benebono-fr" : "https://www.linkedin.com/company/benebono-fr",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets__WEBPACK_IMPORTED_MODULE_4__/* .Linkedin */ .n6, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer_benebono_info",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.email")
                            }),
                            lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.openhour")
                            }),
                            lang === "es" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.phonenumber")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.address")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.certification")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("footer.certification.code")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./components/Nav/Nav.js
var Nav = __webpack_require__(4193);
// EXTERNAL MODULE: ./components/PageLayout/PlasmicWrapper.jsx
var PlasmicWrapper = __webpack_require__(2567);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Footer/Footer.js
var Footer = __webpack_require__(61);
// EXTERNAL MODULE: ./utils/helpers/useStorage.js
var useStorage = __webpack_require__(7034);
// EXTERNAL MODULE: ./components/PromotionBanner/PromotionBanner.js
var PromotionBanner = __webpack_require__(9262);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 47 modules
var esm = __webpack_require__(7561);
;// CONCATENATED MODULE: ./components/DixaChat/DixaChat.jsx

const DIXA_KEY = (/* unused pure expression or super */ null && (""));
function DixaChatOpener() {
// useEffect(() => {
//   if (typeof window !== "undefined" && window._dixa_) {
//     window?._dixa_?.invoke("init", {
//       messengerToken: DIXA_KEY,
//       showWidgetCloseButton: true,
//     });
//   }
// }, []);
}

;// CONCATENATED MODULE: ./components/PageLayout/PageLayout.jsx












function PageLayout(param) {
    let { locale , head , navigation , body , footer , slug  } = param;
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { setItem , getItem  } = (0,useStorage/* default */.Z)();
    const [promotionCode, setpromotionCode] = (0,react.useState)();
    let promotionCodeData = [
        {
            pc: "promotion_code",
            message: {
                main: "message",
                cta: "cta",
                basket: "message"
            },
            amount: 0
        }
    ];
    (0,react.useEffect)(()=>{
        //when we have a promotion code in as a query param
        if (router.query.pc) {
            let pc = router.query.pc;
            // make sure it's a valid one
            let promotionCodeList = promotionCodeData.filter((data)=>data.pc === pc);
            if (promotionCodeList.length > 0) {
                let promotionCode = promotionCodeList[0];
                setItem("pc", JSON.stringify(promotionCode), "session");
            }
        }
        let sessionPromotionCode = getItem("pc", "session");
        if (sessionPromotionCode) {
            setpromotionCode(JSON.parse(sessionPromotionCode));
        }
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadCompononent, {
                title: head === null || head === void 0 ? void 0 : head.title,
                og: head === null || head === void 0 ? void 0 : head.og,
                slug: slug,
                description: t("head.description")
            }),
            navigation.links != null && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                links: navigation.links,
                name: navigation.name
            }),
            promotionCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionBanner/* default */.Z, {
                main_message: promotionCode.message.main,
                cta_message: promotionCode.message.cta,
                has_link: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlasmicWrapper/* default */.Z, {
                plasmicData: body.plasmic.plasmicData,
                queryCache: body.plasmic.queryCache,
                locale: locale,
                query: router.query,
                pageParams: router.params
            }),
            locale === "fr" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DixaChatOpener, {}),
            footer != null && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                links: footer.links,
                locale: locale
            })
        ]
    });
}
const HeadCompononent = (param)=>{
    let { title , og , slug , description  } = param;
    //should we render meta tag only if they have value ?
    //should we force values in strapi ?
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: og === null || og === void 0 ? void 0 : og.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: og === null || og === void 0 ? void 0 : og.siteName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: og === null || og === void 0 ? void 0 : og.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: og === null || og === void 0 ? void 0 : og.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: og === null || og === void 0 ? void 0 : og.image
            }),
             false && /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                hrefLang: "fr-FR",
                href: "https://benebono.fr/".concat(slug)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                hrefLang: "es-ES",
                href: "https://benebono.es/".concat(slug)
            })
        ]
    });
};


/***/ }),

/***/ 2567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _plasmicapp_loader_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6507);
/* harmony import */ var _plasmic_init__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7506);



const PlasmicWrapper = (param)=>{
    let { plasmicData , queryCache , locale , pageParams , componentProps , query  } = param;
    const compMeta = plasmicData.entryCompMetas[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_plasmicapp_loader_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .PlasmicRootProvider */ .UF, {
        loader: _plasmic_init__WEBPACK_IMPORTED_MODULE_2__/* .PLASMIC */ .p,
        prefetchedData: plasmicData,
        prefetchedQueryData: queryCache,
        pageParams: pageParams || compMeta.params,
        pageQuery: query,
        globalVariants: [
            {
                name: "Locale",
                value: locale
            }
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_plasmicapp_loader_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .PlasmicComponent */ .i9, {
            component: compMeta.displayName,
            componentProps: componentProps
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlasmicWrapper);


/***/ }),

/***/ 9262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PromotionBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



function PromotionBanner(param) {
    let { main_message , cta_message , has_link  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "promotion_banner",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: main_message
            }),
            has_link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/checkout",
                children: cta_message
            })
        ]
    });
}


/***/ }),

/***/ 3214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_PageLayout_PageLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1575);



var __N_SSG = true;
function Page(param) {
    let { locale , head , navigation , body , footer , slug , ...rest } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var _window_rudderanalytics;
        window === null || window === void 0 ? void 0 : (_window_rudderanalytics = window.rudderanalytics) === null || _window_rudderanalytics === void 0 ? void 0 : _window_rudderanalytics.page();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageLayout_PageLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        head: head,
        locale: locale,
        navigation: navigation,
        body: body,
        footer: footer,
        slug: slug
    });
}


/***/ }),

/***/ 7034:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const useStorage = ()=>{
    const storageType = (type)=>"".concat(type !== null && type !== void 0 ? type : "session", "Storage");
    const isBrowser = (()=>"object" !== "undefined")();
    const getItem = (key, type)=>{
        return isBrowser ? window[storageType(type)][key] : "";
    };
    const setItem = (key, value, type)=>{
        if (isBrowser) {
            window[storageType(type)].setItem(key, value);
            return true;
        }
        return false;
    };
    const removeItem = (key, type)=>{
        window[storageType(type)].removeItem(key);
    };
    return {
        getItem,
        setItem,
        removeItem
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useStorage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,664,789,507,193,506,888,179], function() { return __webpack_exec__(3076); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);